import type { Client, OptimizelyUserContext } from '@optimizely/optimizely-sdk';
import { createContext, useContext } from 'react';

// Actions
export const SET_CLIENT = 'SET_CLIENT';
export const SET_USER = 'SET_USER';

export type Action =
  | { type: typeof SET_CLIENT; client: Client }
  | { type: typeof SET_USER; user: OptimizelyUserContext | null };

export type Dispatch = (action: Action) => void;

export type State = {
  client?: Client;
  user: OptimizelyUserContext | null;
  loading: boolean; // loading will be used to wait for the user context and decision
};

export const initialState = { user: null, loading: true };

export const OptimizelyContext = createContext<State | undefined>(undefined);
export const OptimizelyDispatchContext = createContext<Dispatch | undefined>(
  undefined,
);

export const useOptimizelyState = () => {
  const context = useContext(OptimizelyContext);

  if (!context) {
    throw new Error(
      'Cannot use `useOptimizelyState` outside of a OptimizelyProvider',
    );
  }

  return context;
};

// Reducer
export const optimizelyReducer = (state: State, action: Action) => {
  switch (action.type) {
    case SET_CLIENT: {
      return { ...state, client: action.client };
    }

    case SET_USER: {
      return { ...state, user: action.user, loading: false };
    }

    default:
      return state;
  }
};
